function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.0696 1.44122H14.4122V0.576488C14.4122 0.258122 14.1541 0 13.8357 0C13.5173 0 13.2592 0.258122 13.2592 0.576488V1.44122H5.18839V0.576488C5.18839 0.258122 4.9303 0 4.6119 0C4.2935 0 4.03541 0.258122 4.03541 0.576488V1.44122H2.37801C1.06675 1.44122 0 2.50797 0 3.81923V16.0696C0 17.3808 1.06675 18.4476 2.37801 18.4476H16.0696C17.3808 18.4476 18.4476 17.3808 18.4476 16.0696V3.81923C18.4476 2.50797 17.3808 1.44122 16.0696 1.44122ZM2.37801 2.59419H4.03541V3.17068C4.03541 3.48905 4.2935 3.74717 4.6119 3.74717C4.9303 3.74717 5.18839 3.48905 5.18839 3.17068V2.59419H13.2592V3.17068C13.2592 3.48905 13.5173 3.74717 13.8357 3.74717C14.1541 3.74717 14.4122 3.48905 14.4122 3.17068V2.59419H16.0696C16.7451 2.59419 17.2946 3.14373 17.2946 3.81923V5.18839H1.15298V3.81923C1.15298 3.14373 1.70251 2.59419 2.37801 2.59419ZM16.0696 17.2946H2.37801C1.70251 17.2946 1.15298 16.7451 1.15298 16.0696V6.34136H17.2946V16.0696C17.2946 16.7451 16.7451 17.2946 16.0696 17.2946Z",
  fill: "#EC270C"
});

const SvgIconCalendar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-calendar.4c28f35b.svg";
export { ForwardRef as ReactComponent };